import * as React from 'react';

import DeliverableInsights from '../../../deliverable-v2/deliverable-insights-tab/deliverable-insights/DeliverableInsights';

import {
  DELIVERABLE_ATTACHMENT_TYPE_ANALYTICS,
  DELIVERABLE_ATTACHMENT_TYPE_HIGHRES
} from 'utils/deliverables';

import {
  Deliverable,
  DeliverableAttachment
} from 'types';

export interface Props {
  isForBrand: boolean,
  isEditMode: boolean,
  deliverable: Deliverable,
  analyticsAttachments: Array<DeliverableAttachment>,
  highresAttachments: Array<DeliverableAttachment>,
  onEditMode: (isEditMode: boolean) => void,
  onAnalyticsAttachmentsUpdate: (att: Array<DeliverableAttachment>) => void,
  onHighresAttachmentsUpdate: (att: Array<DeliverableAttachment>) => void,
  onAnalyticsAttachmentsDelete: (att: Array<DeliverableAttachment>) => void,
  onHighresAttachmentsDelete: (att: Array<DeliverableAttachment>) => void,
  onAnalyticsAttachmentReplace: (rep: DeliverableAttachment, cur: DeliverableAttachment) => void,
  onHighresAttachmentReplace: (rep: DeliverableAttachment, cur: DeliverableAttachment) => void
}

const StorySnippetsSeparatedFromAnalytics = ({
  isForBrand,
  isEditMode,
  deliverable,
  analyticsAttachments,
  highresAttachments,
  onEditMode,
  onAnalyticsAttachmentsUpdate,
  onHighresAttachmentsUpdate,
  onAnalyticsAttachmentsDelete,
  onHighresAttachmentsDelete,
  onAnalyticsAttachmentReplace,
  onHighresAttachmentReplace
}: Props) => (
  <React.Fragment>
    <DeliverableInsights
      isForBrand={isForBrand}
      isEditMode={isEditMode}
      deliverable={deliverable}
      onEditMode={onEditMode}
      attachments={analyticsAttachments}
      onUpdate={onAnalyticsAttachmentsUpdate}
      onDeleteAttachments={onAnalyticsAttachmentsDelete}
      onReplaceAttachment={onAnalyticsAttachmentReplace}
      mode={DELIVERABLE_ATTACHMENT_TYPE_ANALYTICS}
    />
    <DeliverableInsights
      isForBrand={isForBrand}
      isEditMode={isEditMode}
      deliverable={deliverable}
      onEditMode={onEditMode}
      attachments={highresAttachments}
      onUpdate={onHighresAttachmentsUpdate}
      onDeleteAttachments={onHighresAttachmentsDelete}
      onReplaceAttachment={onHighresAttachmentReplace}
      mode={DELIVERABLE_ATTACHMENT_TYPE_HIGHRES}
    />
  </React.Fragment>
);

export default StorySnippetsSeparatedFromAnalytics;
